import { Box } from '@mui/material';
import useOffsetTop from '../../../hooks/ui/useOffsetTop';

interface Props {
  embedId: string;
  path: string;
  title: string;
  anchorRef?: React.RefObject<HTMLElement>;
}

const PADDING_TOP = 32;

export default function PocketflowsEmbed({
  embedId,
  path,
  title,
  anchorRef,
}: Props) {
  const [containerRef, offsetTop, onChange] = useOffsetTop(
    undefined,
    anchorRef,
  );

  return (
    <Box
      ref={(el: HTMLElement) => {
        containerRef.current = el;
        onChange(el);
      }}
      sx={{
        width: '100%',
        minHeight: `calc(100vh - ${offsetTop + PADDING_TOP}px)`,
        position: 'relative',
        flex: 1,
      }}>
      <iframe
        title={title}
        src={`https://api.pocketflows.com/embeds/${embedId}/show/${path}${
          path === 'ads' ? '?show_pf_attribution=1' : ''
        }`}
        width="100%"
        height="100%"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
        frameBorder="0"
      />
    </Box>
  );
}
